import { createContext } from 'react';

const HeaderSnackbarContext = createContext({});

export default HeaderSnackbarContext;
